import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const ModalOfficerInfo = (props) => {
    const [showModal, setShow] = useState(false);

  const setEmail = (officerEmail) => {
    // console.log("In setEmail");
    if(officerEmail.includes('/')){
        let emailsArray = props.officerEmail.split('/');
        // console.log(emailsArray);
        return(
            <>
            <a href={"mailto:" + emailsArray[0].trim()}>{emailsArray[0].trim()}</a>
            &nbsp;and&nbsp;
            <a href={"mailto:" + emailsArray[1].trim()}>{emailsArray[1].trim()}</a>
            </>
        )
    }else {
        return(
            <a href={"mailto:" + officerEmail}>{officerEmail}</a>
        )
    }
  }

//   useEffect(() => {
//     if(props.show){
//         console.log("Setting overflow to hidden");
//         document.body.style.overflow = 'hidden'
//     }
//     if(!props.show){
//         console.log("Setting overflow to auto");
//         document.body.style.overflow = 'auto'
//     }

//   },[props.show])

  return (
    <React.Fragment>
      <Modal 
        show={props.show} 
        onHide={props.hide} 
        size="lg"
        centered
        scrollable='true'
        backdrop='static'
        >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-officer-info">Officer's Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <h5>{props.officerName}</h5>
            <p>
                Email: {setEmail(props.officerEmail)}
            </p>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={props.hide}>Close</Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );

}


export default ModalOfficerInfo;